import { Injectable } from '@angular/core';
import {Observable} from "rxjs";
import {webServiceConfig} from "../config/web-service.config";
import {map} from "rxjs/operators";
import {HttpClient} from "@angular/common/http";
@Injectable({
    providedIn: 'root'
})
export class GroupBrandService {
    constructor(private http: HttpClient) { }

    getBrands(categoryId: any): Observable<any> {
        return this.http.get(`${webServiceConfig.webServiceUrl}group-brands/${categoryId}`).pipe(map(response => {
            return response;
        }));
    }
}
